/* eslint-disable no-await-in-loop */
import {
  createPage,
  addBackgroundImageToPage,
} from '../redux/actions/entities/pages';
import { setFirstLayout } from '../redux/helpers/loadDefaulState';
import { generateWeddingTexts } from '../redux/helpers/texts';
import { changeTextProperty } from '../redux/actions/entities/texts';
import { MmToPx, configExist } from '../redux/helpers';
import { getDomain, getParam } from '../redux/helpers/getParams';
import { changeBookBackgroundType } from '../redux/actions/ui/bookProperties';
import { loadBackgrounds } from '../redux/actions/backgrounds';
import getFontFamilies from '../components/text-tools/font-family/Fonts';


export const letterOfInvitation = 'letterOfInvitation';
export const sticker = 'sticker';
export const tableNumber = 'tableNumber';
export const letterOfInvitationPortrait = 'letterOfInvitationPortrait';
export const letterOfInvitationLandscape = 'letterOfInvitationLandscape';
export const placeCard = 'placeCard';
export const guestBook = 'guestBook';
export const creative = 'Creative';
export const standard = 'Standard';

export function isLetterOfInvitation(pageType) {
  return (
    pageType === letterOfInvitationPortrait ||
    pageType === letterOfInvitationLandscape
  );
}

export function disableButtonsByType(type) {
  const disableTypes = [
    guestBook,
    letterOfInvitationPortrait,
    letterOfInvitationLandscape,
    letterOfInvitation,
    sticker,
  ];

  if (disableTypes.includes(type)) {
    return true;
  }
  return false;
}

export async function generateTableNumbers(quantity, store, page, data) {
  return new Promise(async (resolve) => {
    const quantityArray = [...Array(parseInt(quantity, 10)).keys()];

    for (const index of quantityArray) {
      await store.dispatch(createPage(Object.assign({}, page, { order: index })));
      const firstPage = index === 0;
      const layoutId = store.getState().entities.layouts.allIds;
      const pageId = store.getState().entities.pages.allIds;
      await setFirstLayout(store, layoutId[0], pageId[index], firstPage);
      const text = {
        text: String(index + 1),
        font: data.font,
        fontSize: 220,
        positions: {
          x: 0,
          y: 0,
        },
      };
      for (const page of data.pages[0].backgroundPlaceholder) {
        await generateWeddingTexts(store, text, pageId[index]);
      }
    }
    resolve(true);
  });
}

function calculatTextPosition(
  layoutsById,
  layout,
  imageHeight,
  BgPProperties,
  imageWidth,
  textIndex,
) {
  const {
    width, height, top, left,
  } = BgPProperties;

  // set image to center of the backround placeholder (vertical and horizontal)
  const coordsInPx = {
    left: MmToPx(left),
    top: MmToPx(top),
    height: MmToPx(height),
    width: MmToPx(width),
    layoutHeight: MmToPx(layoutsById[layout].height),
  };

  const portraitTextMargin = 160;

  let positions = {
    x: (coordsInPx.left + (coordsInPx.width / 2)) - (imageWidth / 2),
    y: (coordsInPx.top + (coordsInPx.height / 2)) - (imageHeight / 2),

  };

  const isInvOrGuest =
    isLetterOfInvitation(layoutsById[layout].type) ||
    layoutsById[layout].type === guestBook;
  if (isInvOrGuest) {
    let yCoord = coordsInPx.top + portraitTextMargin;

    if (layoutsById[layout].type === letterOfInvitationPortrait) {
      yCoord = coordsInPx.top + portraitTextMargin;
    }

    // set second image to bottom of the placeholder (2 image / page)
    if (textIndex % 2 === 0) {
      if (layoutsById[layout].type === letterOfInvitationLandscape) {
        yCoord =
          coordsInPx.layoutHeight -
          coordsInPx.top -
          ((imageHeight + portraitTextMargin) - 60);
      } else if (layoutsById[layout].type === letterOfInvitationPortrait) {
        yCoord =
          (coordsInPx.height + coordsInPx.top) - (imageHeight + portraitTextMargin);
      } else {
        yCoord =
        (coordsInPx.height + coordsInPx.top) - (imageHeight + portraitTextMargin);
      }
    }

    positions = {
      x: (coordsInPx.left + (coordsInPx.width / 2)) - (imageWidth / 2),
      y: yCoord,
    };
  }
  return positions;
}

export async function setGeneratedTextToCorrectPosition(store) {
  const getState = store.getState();
  const { entities } = getState;
  const {
    texts, pages, backgroundPlaceholders, layouts,
  } = entities;

  const { byId } = pages;
  const { byId: bgById } = backgroundPlaceholders;
  const { byId: layoutsById } = layouts;

  for (const page of byId) {
    const { backgroundPlaceholders: pageBgP, texts: pageTexts, layout } = page;

    let textIndex = 1;
    for (const text of pageTexts) {
      const { images, isDefault } = texts[text];
      const { width: imageWidth, height: imageHeight } = images.thumbnail;

      let tIndex = 0;
      for (const [index, bgPlaceholder] of Object.entries(pageBgP)) {
        const { backgroundPlaceholderId } = bgPlaceholder;
        const BgPProperties = bgById[backgroundPlaceholderId];

        const setTextID =
          isLetterOfInvitation(layoutsById[layout].type) ||
          layoutsById[layout].type === guestBook
            ? text
            : pageTexts[tIndex];
        const positions = calculatTextPosition(
          layoutsById,
          layout,
          imageHeight,
          BgPProperties,
          imageWidth,
          textIndex,
        );


        if (isDefault) {
          store.dispatch(changeTextProperty(setTextID, 'positions', positions));
        }
        tIndex += 1;
      }
      textIndex += 1;
    }
  }
}

// Create new child product
export async function getParentStyle(prodID) {
  const referer = getDomain();
  const getParent = configExist('getStateUrl', referer);
  const fetchURL = `${getParent}/getParentStyle/${prodID}`;
  const style = await fetch(fetchURL, {
    cors: 'no-cors',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    credentials: 'include',
  });
  return style.json();
}

export async function setParentBackground(data, store) {
  if ('success' in data && data.success && 'background' in data.success) {
    const { background } = data.success;
    const { backgroundImage, category, type } = background;
    const { backgrounds } = store.getState().backgrounds;
    const { byId } = store.getState().entities.layouts;
    store.dispatch(addBackgroundImageToPage(
      category,
      byId,
      backgrounds,
      backgroundImage,
      type,
    ));
    await store.dispatch(changeBookBackgroundType(type));
  }
}

// Load background from API
export async function loadProductBackgrounds(dispatch, productType) {
  const backgroundApi = configExist('backgroundApiURL', getDomain());
  const background = await fetch(`${backgroundApi}/${productType}/${getParam('lang')}`);
  const result = await background.json();
  if ('status' in result) {
    await dispatch(loadBackgrounds(result.status[0]));
  }
  return result;
}

// Set default text size by parent font...
export async function setFontSizeByParentFont(fontName, productType, lang) {
  const fonts = getFontFamilies(lang);
  const fontNames = Object.values(fonts).map(el => el.font);
  const guestBookSizes = [[[200, 95]], [[150, 90]], [[150, 90]], [[180, 90]], [[200, 110]], [[150, 95]], [[150, 95]], [[140, 75]], [[120, 90]], [[170, 70]], [[180, 135]], [[120, 90]], [[120, 90]], [[125, 95]], [[135, 100]], [[200, 130]], [[150, 95]], [[160, 100]], [[140, 95]]];

  const letterOfInvitationPortraitSizes = [
    [[80, 50], [60, 35], [50]],
    [[60, 20], [40, 30], [40]],
    [[90, 55], [50, 50], [40]],
    [[80, 55], [50, 50], [40]],
    [[110, 65], [60, 60], [40]],
    [[90, 45], [45, 45], [40]],
    [[90, 45], [45, 45], [40]],
    [[70, 35], [35, 35], [40]],
    [[70, 45], [35, 35], [40]],
    [[70, 45], [50, 50], [40]],
    [[100, 55], [50, 50], [40]],
    [[90, 60], [40, 40], [40]],
    [[90, 50], [40, 40], [40]],
    [[90, 50], [40, 40], [40]],
    [[90, 50], [40, 40], [40]],
    [[90, 50], [40, 40], [40]],
    [[90, 50], [40, 40], [40]],
    [[90, 50], [40, 40], [40]],
    [[90, 50], [40, 40], [40]],
  ];

  const letterOfInvitationLandscapeSizes = [
    [[90, 70], [60, 60], [50]],
    [[80, 45], [40, 40], [40]],
    [[90, 55], [45, 45], [40]],
    [[80, 55], [50, 50], [40]],
    [[110, 65], [60, 60], [40]],
    [[90, 45], [45, 45], [40]],
    [[90, 45], [45, 45], [40]],
    [[70, 35], [35, 35], [40]],
    [[70, 45], [35, 35], [40]],
    [[70, 45], [50, 50], [40]],
    [[100, 80], [50, 50], [40]],
    [[75, 60], [40, 40], [40]],
    [[90, 50], [40, 40], [40]],
    [[90, 50], [40, 40], [40]],
    [[90, 50], [40, 40], [40]],
    [[90, 50], [40, 40], [40]],
    [[90, 50], [40, 40], [40]],
    [[90, 50], [40, 40], [40]],
    [[90, 50], [40, 40], [40]],
  ];

  const sizeCases = {
    guestBook: guestBookSizes,
    TableNumbers: [[[95, 200]]],
    letterOfInvitationPortrait: letterOfInvitationPortraitSizes,
    letterOfInvitationLandscape: letterOfInvitationLandscapeSizes,
  };

  const fontIndex = fontNames.indexOf(fontName);
  return sizeCases[productType][fontIndex];
}


export function generateButtonTexts(type, lang) {
  switch (type) {
    case tableNumber:
      return {
        addNew: lang.addNewTableNumber,
        delete: lang.deleteTableNumber,
      };
    case placeCard: {
      return {
        addNew: lang.addNewPlaceCard,
        delete: lang.deletePlaceCard,
      };
    }
    default:
      return {
        addNew: lang.top_menu_new_page,
        delete: lang.top_menu_delete_page,
      };
  }
}



// WEBPACK FOOTER //
// ./src/helpers/weddingHelper.jsx